import { gql } from "@at/sauron-platform-graphql";

export const leasingTechnicalSpecificationQuery = gql`
  query LeasingTechnicalSpecificationQuery(
    $advertId: String!
    $leaseOption: String
  ) {
    search {
      advert(advertId: $advertId, leaseOption: $leaseOption) {
        id
        specification {
          derivative
          derivativeId
          doors
          fuel
          make
          model
          seats
          style
          trim
          optionalFeatures {
            description
          }
          battery {
            capacity {
              capacity
              unit
            }
            usableCapacity {
              capacity
              unit
            }
            range {
              range
              unit
            }
            charging {
              chargeTime
              quickChargeTime
            }
          }
          techData {
            bodyStyle
            engineSize
            fuelType
            numberOfDoors
            numberOfSeats
            transmission
            warrantyMiles
            warrantyYears
            enginePower
            zeroToSixtyMph
            insuranceGroup
            topSpeed
            engineTorque
            vehicleHeight
            vehicleLength
            wheelbase
            vehicleWidth
            fuelTankCapacity
            luggageCapacitySeatsDown
            bootspaceSeatsUp
            maxLoadingWeight
            minimumKerbWeight
            standardFeatures {
              category
              description
            }
          }
        }
      }
    }
  }
`;
